module.exports = __webpack_public_path__ + "static/img/case_1.6460bb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ShopSelfPrinting/case_1.png
// module id = WIlk
// module chunks = 10